import CollapseWrapper from '../collapse/wrapper.vue'

/* istanbul ignore next */
CollapseWrapper.install = function (Vue) {
  Vue.component(CollapseWrapper.name, CollapseWrapper)
}

export default CollapseWrapper
